import { withRouter } from 'react-router-dom';
import SedersPage from './SedersPage';

export default withRouter(SedersPage);
